import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOrganization } from '@common/interfaces/IOrganization';

interface OrgState {
  orgId: string;
  org: IOrganization | null;
}

const orgSlice = createSlice({
  name: 'org',
  initialState: { orgId: '', org: null } as OrgState,
  reducers: {
    setOrgId: (state, action: PayloadAction<string>) => {
      state.orgId = action.payload;
    },
    setOrg: (state, action: PayloadAction<IOrganization>) => {
      state.org = action.payload;
      state.orgId = action.payload.id;
    },
  },
});

export const { setOrgId, setOrg } = orgSlice.actions;
export default orgSlice.reducer;
